import types from './action-types';

export const initialState = {
  ui: {
    isResendingConfirmationEmail: false,
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.RESEND_CONFIRMATION_EMAIL:
      return {
        ...state,
        ui: {
          ...state.ui,
          isResendingConfirmationEmail: true,
        },
      };

    case types.RESEND_CONFIRMATION_EMAIL_RESULT: {
      return {
        ...state,
        ui: {
          ...state.ui,
          isResendingConfirmationEmail: false,
        },
      };
    }

    default:
      return state;
  }
}

const stateKey = 'portalEmailConfirmation';

export const getComponentState = state => state[stateKey];

export default { [stateKey]: reducer };
